var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticContentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3178 17.4155C2.25371 17.6361 2.31582 17.8741 2.47955 18.0352C2.64327 18.1964 2.88221 18.2548 3.10179 18.1872L9.68921 16.1603V9.06384C9.68921 8.71867 9.96903 8.43884 10.3142 8.43884C10.6594 8.43884 10.9392 8.71867 10.9392 9.06384V16.1603L17.5264 18.1871C17.746 18.2547 17.9849 18.1963 18.1487 18.0352C18.3124 17.874 18.3745 17.636 18.3104 17.4154C16.6887 11.8332 14.1321 6.64932 10.8215 2.04445C10.704 1.88111 10.5152 1.78428 10.314 1.78429C10.1128 1.78429 9.92396 1.88112 9.80654 2.04446C6.49601 6.64936 3.93938 11.8333 2.3178 17.4155Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticContentIcon);
export default __webpack_public_path__ + "static/media/analyticContentIcon.5315fbd48ae81c93ec72c5fe29692bb5.svg";
export { ForwardRef as ReactComponent };